<template>
    <div class="cl-modal-cont">
        <v-card class="cl-modal-card-cont">
            <div class="cl-modal-close-cont">
                <img class="cl-modal-close" src="../assets/image/close-circle.png" alt="close" @click="onPressClose">
            </div>
            <v-card-text class="cl-modal-content-cont">
                <div class="cl-modal-left-col">
                    <img class="cl-modal-img" :src="loopDetails.coverUrl" alt="info-icon"/>
                    <div class="cl-loop-title-cont-mobile">
                        <div class="cl-modal-pack-title">{{ loopDetails.title }}</div>
                        <div class="cl-modal-sample-count">{{ `${loopDetails.stemUrls.length} Sample${loopDetails.stemUrls.length === 1 ? '': 's'}`}}</div>
                    </div>
                    <div class="cl-modal-play-mobile">
                        <img v-if="!isDemoPlaying" class="cl-modal-play-demo-icon" src="../assets/image/play-demo.png" alt="play" @click="onPressPlayDemo"/>
                        <img v-if="isDemoPlaying" class="cl-modal-play-demo-icon" src="../assets/image/pause-demo.png" alt="pause" @click="onPressPauseDemo"/>
                        <div class="cl-modal-play-demo-text">{{ isDemoPlaying ? 'Pause' : 'Play' }} Demo</div>
                    </div>
                    <div class="cl-modal-download-pack-btn" @click.prevent="downloadPack">Download Pack</div>
                    <div class="cl-modal-stats">
                        <div class="cl-stat">{{ `${loopDetails.stemUrls.length} Sample${loopDetails.stemUrls.length === 1 ? '': 's'}`}}</div>
                        <div class="cl-stat">Music Genre > {{ genre }}</div>
                        <div class="cl-stat">{{ loopDetails.bpm }} bpm</div>
                    </div>
                    <div class="cl-pack-desc">
                        {{ loopDetails.description }}
                    </div>
                </div>
                <div class="cl-modal-right-col">
                    <div class="cl-loop-title-cont">
                        <div class="cl-modal-pack-title">{{ loopDetails.title }}</div>
                        <div class="cl-modal-sample-count">{{ `${loopDetails.stemUrls.length} Sample${loopDetails.stemUrls.length === 1 ? '': 's'}`}}</div>
                    </div>
                    <div class="cl-modal-play">
                        <img v-if="!isDemoPlaying" class="cl-modal-play-demo-icon" src="../assets/image/play-demo.png" alt="play" @click="onPressPlayDemo"/>
                        <img v-if="isDemoPlaying" class="cl-modal-play-demo-icon" src="../assets/image/pause-demo.png" alt="pause" @click="onPressPauseDemo"/>
                        <div class="cl-modal-play-demo-text">{{ isDemoPlaying ? 'Pause' : 'Play' }} Demo</div>
                    </div>
                    <div class="cl-stem-cont">
                        <LoopStem v-for="(stem, index) in loopDetails.stemUrls" :key="index" :stem="stem" :index="index+1" :onPressStem="onPressStem" :isPlaying="stemIsPlaying(stem.downloadUrl) && !isPaused"/>
                    </div>
                </div>
            </v-card-text>
        </v-card>
        <audio id="collab-modal-player" ref="collabModalPlayer" :src="audioFile"/>
    </div>
</template>
<script>
    import downloadUrl from "../util";
    import LoopStem from "./LoopStem";
    export default {
      name: 'LoopPackModal',
      props: {
        onCloseLoopPack: {
          type: Function
        },
        loopDetails: {
          type: Object,
          required: true
        },
        genre: {
          type: String
        }
      },
      components: {
        LoopStem
      },
      data() {
        return {
          currentTrack: '',
          isPlaying: false,
          isDemoPlaying: false,
          demoStarted: false,
          isPaused: true,
          songLoaded: false,
        }
      },
      methods: {
        // Music Controls:
        play() {
          /*eslint no-unused-vars:*/
          this.audio.play().then(_ => {
            this.isPlaying = true;
            this.isPaused = false
          });
        },
        pause() {
          this.isPaused = true;
          this.isPlaying = false;
          this.audio.pause();
          if (this.isDemoPlaying) {
            this.isDemoPlaying = false;
          }
        },
        stop() {
          this.audio.pause();
          this.audio.currentTime = 0;
          this.isPaused = true;
          this.isPlaying = false;
          if (this.isDemoPlaying) {
            this.isDemoPlaying = false;
            this.demoStarted = false;
          }
        },
        _handleLoaded: function () {
          if (this.audio.readyState >= 2) {
            this.songLoaded = true;
          } else {
            this.songLoaded = false;
            throw new Error('Failed to load sound file')
          }
        },
        _handleEnded () {
          this.stop();
        },
        init: function () {
          this.audio.addEventListener('loadeddata', this._handleLoaded);
          this.audio.addEventListener('ended', this._handleEnded);
        },
        // End music controls
        onPressPlayDemo() {
          this.currentTrack = this.loopDetails.demoUrl;
          this.isDemoPlaying = true;
          this.demoStarted = true;
          this.$nextTick(() => {
            this.play();
          });
        },
        onPressPauseDemo() {
          this.isDemoPlaying = false;
          this.pause();
        },
        downloadPack() {
          downloadUrl(this.loopDetails.zipUrl);
        },
        onPressStem(stem) {
          if (stem === this.currentTrack && !this.isPaused) {
            this.pause();
            return;
          }
          this.currentTrack = stem;
          if (this.isDemoPlaying) {
            this.isDemoPlaying = false;
            this.demoStarted = false;
          }
          this.$nextTick(() => {
            this.play();
          });
        },
        onPressClose() {
          this.stop();
          this.onCloseLoopPack();
        }
      },
      computed: {
        audioFile() {
          if (typeof this.currentTrack === 'string') {
            return this.currentTrack;
          } else if (typeof this.currentTrack === 'object') {
            return this.currentTrack.downloadUrl;
          } else {
            return ''
          }
        },
        stemIsPlaying: function() {
          return (stemUrl) => this.audioFile === stemUrl;
        }
      },
      mounted() {
        this.audio = this.$refs.collabModalPlayer;
        this.init();
      },
      beforeDestroy () {
        this.audio.removeEventListener('loadeddata', this._handleLoaded);
        this.audio.removeEventListener('ended', this._handleEnded);
      },
    }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
    .cl-modal-cont {
        border-radius: 2px;
        display: flex;
        justify-content: center;
        color: white;
    }

    .cl-modal-card-cont {
        background-color: black;
        border-radius: 3px;
        padding: 3%;
        width: 1000px;
        overflow: scroll;
    }

    .cl-modal-close-cont {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .cl-modal-close {
        width: 40px;
        height: 40px;
        cursor: pointer;

        &:hover {
            filter: brightness(85%);
        }
    }

    .cl-modal-content-cont {
        display: flex;
        justify-content: space-evenly;
    }

    .cl-modal-left-col {
        margin-right: 50px;
    }

    .cl-modal-img {
        width: 350px;
        height: 350px;
        object-fit: cover;
        border-radius: 6px;
    }

    .cl-modal-download-pack-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 50px;
        border-radius: 25px;
        background-color: #e1a732;
        color: black;
        font-family: Lato-Bold, sans-serif;
        font-size: 15px;
        cursor: pointer;
        margin-top: 24px;
        text-transform: uppercase;

        &:hover {
            filter: brightness(120%);
        }
    }

    .cl-modal-stats {
        display: flex;
        margin: 24px 0;
    }

    .cl-stat {
        margin-right: 10px;
        font-family: Lato-Regular, sans-serif;
        font-size: 15px;
    }

    .cl-pack-desc {
        width: 350px;
        font-family: Lato-Regular, sans-serif;
        font-size: 17px;
        font-style: normal;
        font-stretch: normal;
    }

    .cl-modal-pack-title, .cl-modal-sample-count {
        font-family: Lato-Bold, sans-serif;
        font-size: 30px;
        font-weight: bold;
    }

    .cl-modal-sample-count {
        color: #e4e4e4;
        margin-top: 10px;
    }

    .cl-modal-play {
        display: flex;
        width: 160px;
        align-items: center;
        margin-top: 15px;
    }

    .cl-loop-title-cont-mobile {
        display: none;
    }

    .cl-modal-play-mobile {
        display: none;
    }

    .cl-modal-play-demo-icon {
        width: 47px;
        height: 47px;
        cursor: pointer;

        &:hover {
            filter: brightness(80%);
        }
    }

    .cl-modal-play-demo-text {
        color: #e1a732;
        font-size: 17px;
        margin-left: 15px;
        font-family: Lato-Bold, sans-serif;
        text-transform: uppercase;
    }

    @media (min-width: 768px) and (max-width: 835px) {
        .cl-modal-cont {
            width: 780px;
        }

        .cl-modal-card-cont {
            width: 780px;
        }

        .cl-modal-img {
            width: 280px;
            height: 280px;
        }

        .cl-modal-download-pack-btn {
            width: 280px;
        }

        .cl-pack-desc {
            width: 280px;
        }

        .cl-loop-title-cont-mobile {
            display: none;
        }

        .cl-modal-close-cont {
            margin-top: 20px;
        }

        .cl-modal-sample-count {
            margin-top: 15px;
        }
    }

    @media (max-width: 600px) {
        .cl-modal-card-cont {
            padding: 4%;
            overflow-x: scroll;
        }

        .cl-modal-content-cont {
            flex-direction: column;
            align-items: center;
            overflow: scroll;
        }

        .cl-modal-img {
            width: 260px;
            height: 260px;
        }

        .cl-modal-download-pack-btn {
            width: 260px;
        }

        .cl-modal-left-col {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0;
        }

        .cl-modal-pack-title, .cl-modal-sample-count {
            font-size: 17px;
            font-weight: bold;
            width: 70%;
        }

        .cl-modal-pack-title {
            margin-top: 15px;
        }

        .cl-modal-sample-count {
            margin-bottom: 15px;
            margin-top: 0;
        }

        .cl-modal-play {
            display: none;
        }

        .cl-loop-title-cont {
            display: none;
        }

        .cl-loop-title-cont-mobile {
            display: inherit;
            flex-direction: column;
            width: 100%;
            margin-left: 120px;
        }

        .cl-modal-play-mobile {
            display: flex;
            align-items: center;
            align-self: flex-start;
            margin-left: 60px;
        }

        .cl-modal-play-demo-text {
            font-size: 15px;
        }

        .cl-modal-play-demo-icon {
            width: 35px;
            height: 35px;
        }

        .cl-pack-desc {
            font-size: 12px;
            text-align: center;
            width: 300px;
        }

        .cl-stat {
            font-size: 12px;
        }
    }
</style>